import { FC, useMemo } from "react";
import { Box, Typography } from "@material-ui/core";
import { InfoBox } from "componentsNew/elements/InfoBox";
import { getFilteredFleetReports } from "hooks/useFleetReports";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useStyles } from "./styles";

const formatPay = (value: number) =>
  `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const FleetReportsStats: FC = () => {
  const classes = useStyles();
  const { fleetReportList, fleetReportFilters } = useTypeSelectors((state) => state.fleetReports);

  const fleetSummary = useMemo(() => {
    const rows = getFilteredFleetReports(fleetReportList, fleetReportFilters);
    return [
      {label: rows.length, value: "Total"},
      {label: rows.filter((van) => van.size === "Small").length, value: "Small"},
      {label: rows.filter((van) => van.size === "Large").length, value: "Large"},
      {label: rows.filter((van) => van.size === "Cube").length, value: "Cube"},
      {label: rows.filter((van) => van.size === "Truck").length, value: "Truck"},
      {label: rows.filter((van) => van.size === "Caravan").length, value: "Caravan"},
      {label: rows.filter((van) => van.size === "Medium").length, value: "Medium"},
    ] 
  }, [fleetReportList, fleetReportFilters]);

  const paymentTotals = useMemo(() => {
    const rows = getFilteredFleetReports(fleetReportList, fleetReportFilters);

    return rows.reduce(
      (acc, row) => ({
        rate: acc.rate + Number(row.rate || 0),
        invoice: acc.invoice + Number(row.invoice || 0),
        paidAmount: acc.paidAmount + Number(row.paid_amount || 0),
      }),
      { rate: 0, invoice: 0, paidAmount: 0 },
    );
  }, [fleetReportList, fleetReportFilters]);

  return (
    <Box className={classes.statsSection}>
      <Box className={classes.statsContainer}>
        <Typography className={classes.statsTitle}>Fleets Summary</Typography>
        <Box className={classes.statsBox}>
          {
            fleetSummary.map((item) => (
              <InfoBox label={item.label} value={item.value} bigLabel />
            ))
          }
        </Box>
      </Box>
      <Box className={classes.statsContainer}>
        <Typography className={classes.statsTitle}>Payment Summary</Typography>
        <Box className={classes.statsBox}>
          <InfoBox label={formatPay(paymentTotals.rate)} value="Monthly Rate" bigLabel />
          <InfoBox label={formatPay(paymentTotals.invoice)} value="Invoice Value" bigLabel />
          <InfoBox label={formatPay(paymentTotals.paidAmount)} value="Paid Amount" bigLabel />
        </Box>
      </Box>
    </Box>
  );
};

export default FleetReportsStats;